import React, { useEffect, useState } from 'react';
import './Ordenanzas.css'; // Estilo para el componente

const Ordenanzas = () => {
  const [ordenanzas, setOrdenanzas] = useState({});
  const [desplegados, setDesplegados] = useState({});

  useEffect(() => {
    // Simulamos la carga de archivos de ordenanzas organizados por tipo
    const agrupadas = {
      'Agua y Depuración': [
        { nombre: 'Ordenanza sobre Agua', url: '/uploads/ordenanzas/agua-y-depuracion/O.F. agua.pdf' },
        { nombre: 'Ordenanza sobre Depuración', url: '/uploads/ordenanzas/agua-y-depuracion/O.F. tasa depuración.pdf' },
        { nombre: 'Ordenanza reguladora de vertido de aguas residuales', url: '/uploads/ordenanzas/agua-y-depuracion/Ordenanza reguladora de vertido de aguas residuales.pdf' },
        { nombre: 'Reglamento del agua', url: '/uploads/ordenanzas/agua-y-depuracion/Reglamento del agua.pdf' },
      ],
      'Basuras, Escombros y Limpieza Viaria': [
        { nombre: 'Ordenanza sobre Limpieza de solares', url: '/uploads/ordenanzas/basuras-escombros-limpieza/Limpieza de solares.pdf' },
        { nombre: 'Ordenanza sobre precios públicos vertidos escombrera', url: '/uploads/ordenanzas/basuras-escombros-limpieza/escombrera.pdf' },
        { nombre: 'Ordenanza tasas recogida de residuos', url: '/uploads/ordenanzas/basuras-escombros-limpieza/O.F. Tasa recogida de residuos.pdf' },
        { nombre: 'Reglamento uso de la escombrera', url: '/uploads/ordenanzas/basuras-escombros-limpieza/Reglamento de uso de la Escombrera.pdf' },
        { nombre: 'Ordenanza sobre retirada de residuos y limpieza de espacios públicos', url: '/uploads/ordenanzas/basuras-escombros-limpieza/Retirada de residuos y limpieza de espacios publicos.pdf' },
      ],
      'Deporte y Cultura': [
        { nombre: 'Ordenanza sobre piscina e instalaciones deportivas', url: '/uploads/ordenanzas/deporte-y-cultura/O.F. Piscina e instalaciones deportivas.pdf' },
        { nombre: 'Ordenanza tasas por uso de servicios educativos', url: '/uploads/ordenanzas/deporte-y-cultura/O.F. Tasa por uso de servicios educativos.pdf' },
        { nombre: 'Reglamento biblioteca', url: '/uploads/ordenanzas/deporte-y-cultura/Reglamento Biblioteca.pdf' },
        { nombre: 'Reglamento instalaciones deportivas', url: '/uploads/ordenanzas/deporte-y-cultura/Reglamento Instalaciones deportivas.pdf' },
      ],
      'Ocupación y Uso del Dominio Público': [
        { nombre: 'Ordenanza sobre tasas contenedores, vallas, etc', url: '/uploads/ordenanzas/ocupacion-dominio-publico/O.F. Tasa contenedores escombros, vallas, etc.pdf' },
        { nombre: 'Ordenanza tasas mesas y sillas bares', url: '/uploads/ordenanzas/ocupacion-dominio-publico/O.F. Tasa mesas y sillas bares.pdf' },
        { nombre: 'Ordenanza tasas puesto feria y mercadillo', url: '/uploads/ordenanzas/ocupacion-dominio-publico/O.F. Tasa puestos feria y mercadillo.pdf' },
        { nombre: 'Ordenanza tasas tendidos, palomillas y cables', url: '/uploads/ordenanzas/ocupacion-dominio-publico/O.F. Tasa tendidos, palomillas, cables.pdf' },
        { nombre: 'Regulación venta ambulante y mercadillo', url: '/uploads/ordenanzas/ocupacion-dominio-publico/Regulación venta ambulante y mercadillo.pdf' },
      ],
      'Propiedad Inmobiliaria y Urbanismo': [
        { nombre: 'Edificación', url: '/uploads/ordenanzas/propiedad-inmobiliaria-urbanismo/Edificación.pdf' },
        { nombre: 'IBI', url: '/uploads/ordenanzas/propiedad-inmobiliaria-urbanismo/IBI.docx' },
        { nombre: 'Ordenanza tasa alcantarillado', url: '/uploads/ordenanzas/propiedad-inmobiliaria-urbanismo/O.F. Tasa alcantarillado.pdf' },
        { nombre: 'Ordenanza tasa primera ocupación', url: '/uploads/ordenanzas/propiedad-inmobiliaria-urbanismo/O.F. Tasa de primera ocupación.pdf' },
        { nombre: 'Ordenanza tasas licencias urbanísticas', url: '/uploads/ordenanzas/propiedad-inmobiliaria-urbanismo/O.F. Tasa licencias urbanísticas.pdf' },
        { nombre: 'Ordenanza casco antiguo (NNSS)', url: '/uploads/ordenanzas/propiedad-inmobiliaria-urbanismo/ORDENANZA CASCO ANTIGUO (NNSS).docx' },
      ],
      'Servicios': [
        { nombre: 'Ordenanza expedición documentos administrativos', url: '/uploads/ordenanzas/Servicios/O.F. Expedición documentos administrativos.pdf' },
        { nombre: 'Ordenanza tasa cementerio', url: '/uploads/ordenanzas/Servicios/O.F. Tasa Cementerio.pdf' },
        { nombre: 'Ordenanza tasa matrimonios civiles', url: '/uploads/ordenanzas/Servicios/O.F. Tasa matrimonios Civiles.pdf' },
        { nombre: 'Ordenanza tasa participación pruebas selectivas', url: '/uploads/ordenanzas/Servicios/O.F. Tasa participación pruebas selectivas.pdf' },
        { nombre: 'Ordenanza tasa S.A.D.', url: '/uploads/ordenanzas/Servicios/O.F. Tasa S.A.D..pdf' },
      ],
      'Vehículos y Tráfico': [
        { nombre: 'Ordenanza del I.V.T.M.', url: '/uploads/ordenanzas/vehiculos-y-trafico/O.F. del I.V.T.M..pdf' },
        { nombre: 'Ordenanza sobre movilidad', url: '/uploads/ordenanzas/vehiculos-y-trafico/ordenanza de movilidad.pdf' },
      ],
      'Más': [
        { nombre: 'Ordenanza de pastos', url: '/uploads/ordenanzas/Mas/ORDENANZA DE PASTOS.doc' },
      ],
    };

    setOrdenanzas(agrupadas);
  }, []);

  const toggleDesplegar = (tipo) => {
    setDesplegados((prev) => ({
      ...prev,
      [tipo]: !prev[tipo],
    }));
  };

  return (
    <section className="ordenanzas">
      <div className="container">
        <h1>Ordenanzas Municipales</h1>
        <p>Consulta las ordenanzas Municipales.</p>

        {Object.keys(ordenanzas).map((tipo, index) => (
          <div key={index} className="tipo-ordenanza">
            <div className="encabezado-tipo" onClick={() => toggleDesplegar(tipo)}>
              <h2>{tipo}</h2>
              <button className="expand-button">{desplegados[tipo] ? '−' : '+'}</button>
            </div>

            {desplegados[tipo] && (
              <div className="ordenanzas-grid">
                {ordenanzas[tipo].map((ordenanza, i) => (
                  <div key={i} className="ordenanza-card">
                    <a href={ordenanza.url} target="_blank" rel="noopener noreferrer">
                      <p>{ordenanza.nombre}</p>
                    </a>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Ordenanzas;
